import { sentryBrowserInit } from '@core/feature';
sentryBrowserInit();
